import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, vModelText as _vModelText } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "loader-wrap"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "lds-ellipsis" }, [
  /*#__PURE__*/_createVNode("div"),
  /*#__PURE__*/_createVNode("div"),
  /*#__PURE__*/_createVNode("div"),
  /*#__PURE__*/_createVNode("div")
], -1)
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "card" }
const _hoisted_5 = {
  key: 0,
  class: "title"
}
const _hoisted_6 = /*#__PURE__*/_createVNode("i", { class: "fa fa-bookmark mr-1 text-warning" }, null, -1)
const _hoisted_7 = {
  key: 1,
  class: "title"
}
const _hoisted_8 = /*#__PURE__*/_createVNode("i", { class: "fa fa-bookmark mr-1 text-warning" }, null, -1)
const _hoisted_9 = { class: "card" }
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "col-md-4" }
const _hoisted_12 = {
  key: 0,
  class: "row"
}
const _hoisted_13 = /*#__PURE__*/_createVNode("div", { class: "col-md-3" }, [
  /*#__PURE__*/_createVNode("p", null, [
    /*#__PURE__*/_createVNode("strong", null, "Payer Email :")
  ])
], -1)
const _hoisted_14 = { class: "col-md-9" }
const _hoisted_15 = { class: "payer-email-list-display" }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { key: 1 }
const _hoisted_18 = {
  key: 1,
  class: "inline-items align-middle"
}
const _hoisted_19 = /*#__PURE__*/_createVNode("li", null, [
  /*#__PURE__*/_createVNode("p", null, [
    /*#__PURE__*/_createVNode("strong", null, "Members Email :")
  ])
], -1)
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { class: "col-md-8 text-md-right" }
const _hoisted_22 = /*#__PURE__*/_createVNode("i", { class: "far fa-comments mr-2" }, null, -1)
const _hoisted_23 = {
  key: 0,
  class: "with-spinner-btn"
}
const _hoisted_24 = /*#__PURE__*/_createVNode("span", {
  class: "spinner-border",
  role: "status"
}, null, -1)
const _hoisted_25 = /*#__PURE__*/_createVNode("span", { class: "ml-2" }, "Loading...", -1)
const _hoisted_26 = {
  key: 1,
  class: "ml-2"
}
const _hoisted_27 = {
  key: 0,
  class: "with-spinner-btn"
}
const _hoisted_28 = /*#__PURE__*/_createVNode("span", {
  class: "spinner-border",
  role: "status"
}, null, -1)
const _hoisted_29 = /*#__PURE__*/_createVNode("span", { class: "ml-2" }, "Loading...", -1)
const _hoisted_30 = {
  key: 1,
  class: "ml-2"
}
const _hoisted_31 = {
  key: 0,
  class: "mb-0 mt-3"
}
const _hoisted_32 = /*#__PURE__*/_createVNode("strong", null, "Invitation For :", -1)
const _hoisted_33 = { key: 1 }
const _hoisted_34 = {
  key: 2,
  class: "mb-0 mt-3"
}
const _hoisted_35 = /*#__PURE__*/_createVNode("strong", null, "Invitation For :", -1)
const _hoisted_36 = { key: 3 }
const _hoisted_37 = {
  key: 4,
  class: "mb-0 mt-3"
}
const _hoisted_38 = /*#__PURE__*/_createVNode("strong", null, "Details :", -1)
const _hoisted_39 = { key: 5 }
const _hoisted_40 = { class: "row align-items-center" }
const _hoisted_41 = {
  key: 0,
  class: "col-md-8"
}
const _hoisted_42 = { class: "mb-0" }
const _hoisted_43 = /*#__PURE__*/_createVNode("i", { class: "fa fa-calendar-alt mr-2" }, null, -1)
const _hoisted_44 = /*#__PURE__*/_createVNode("strong", null, "Date : ", -1)
const _hoisted_45 = { key: 0 }
const _hoisted_46 = /*#__PURE__*/_createTextVNode(" - ")
const _hoisted_47 = {
  key: 1,
  class: "text-danger"
}
const _hoisted_48 = {
  key: 1,
  class: "col-md-8"
}
const _hoisted_49 = /*#__PURE__*/_createVNode("i", { class: "fa fa-calendar-alt mr-2" }, null, -1)
const _hoisted_50 = /*#__PURE__*/_createVNode("strong", null, "Update Notes : ", -1)
const _hoisted_51 = { key: 0 }
const _hoisted_52 = /*#__PURE__*/_createTextVNode(" - ")
const _hoisted_53 = {
  key: 1,
  class: "text-danger"
}
const _hoisted_54 = {
  key: 2,
  class: "col-md-8"
}
const _hoisted_55 = { class: "mb-0" }
const _hoisted_56 = /*#__PURE__*/_createVNode("i", { class: "fa fa-calendar-alt mr-2" }, null, -1)
const _hoisted_57 = /*#__PURE__*/_createVNode("strong", null, "Involvement Date : ", -1)
const _hoisted_58 = { key: 0 }
const _hoisted_59 = /*#__PURE__*/_createTextVNode(" - ")
const _hoisted_60 = {
  key: 1,
  class: "text-danger"
}
const _hoisted_61 = { class: "col-md-4 text-md-right" }
const _hoisted_62 = {
  key: 0,
  class: "alert alert-success d-inline-block text-center"
}
const _hoisted_63 = /*#__PURE__*/_createVNode("strong", null, "Estimation :", -1)
const _hoisted_64 = {
  key: 6,
  class: "inline-items my-3"
}
const _hoisted_65 = /*#__PURE__*/_createVNode("p", null, [
  /*#__PURE__*/_createVNode("strong", null, "Attachements :")
], -1)
const _hoisted_66 = { key: 7 }
const _hoisted_67 = {
  key: 8,
  class: "mb-0"
}
const _hoisted_68 = /*#__PURE__*/_createVNode("strong", null, "Edoc Link :", -1)
const _hoisted_69 = { key: 9 }
const _hoisted_70 = { key: 10 }
const _hoisted_71 = /*#__PURE__*/_createVNode("strong", null, "Invited Tasks :", -1)
const _hoisted_72 = {
  key: 11,
  class: "table-responsive mb-3 font-12"
}
const _hoisted_73 = { class: "table table-bordered table-shadowed mb-0 mt-3" }
const _hoisted_74 = { class: "table-primary nowrap-text" }
const _hoisted_75 = {
  key: 0,
  scope: "col"
}
const _hoisted_76 = /*#__PURE__*/_createVNode("p", null, "All", -1)
const _hoisted_77 = /*#__PURE__*/_createVNode("th", { scope: "col" }, "Title of Task", -1)
const _hoisted_78 = /*#__PURE__*/_createVNode("th", { scope: "col" }, "Description", -1)
const _hoisted_79 = /*#__PURE__*/_createVNode("th", { scope: "col" }, "Assignees", -1)
const _hoisted_80 = /*#__PURE__*/_createVNode("th", { scope: "col" }, "Start Date", -1)
const _hoisted_81 = /*#__PURE__*/_createVNode("th", { scope: "col" }, "End Date", -1)
const _hoisted_82 = { key: 0 }
const _hoisted_83 = { key: 0 }
const _hoisted_84 = /*#__PURE__*/_createVNode("small", null, [
  /*#__PURE__*/_createVNode("strong", null, "View Tasks")
], -1)
const _hoisted_85 = { key: 0 }
const _hoisted_86 = { key: 1 }
const _hoisted_87 = { key: 1 }
const _hoisted_88 = {
  key: 12,
  class: "table-responsive mb-3 font-12"
}
const _hoisted_89 = /*#__PURE__*/_createVNode("span", { class: "with-spinner-btn" }, [
  /*#__PURE__*/_createVNode("span", { class: "ml-2" }, "See in Calender")
], -1)
const _hoisted_90 = { class: "mt-3" }
const _hoisted_91 = /*#__PURE__*/_createVNode("p", null, [
  /*#__PURE__*/_createVNode("strong", null, "Time Slots ")
], -1)
const _hoisted_92 = { class: "table table-bordered table-shadowed mb-0 mt-2" }
const _hoisted_93 = /*#__PURE__*/_createVNode("thead", { class: "table-primary nowrap-text" }, [
  /*#__PURE__*/_createVNode("tr", null, [
    /*#__PURE__*/_createVNode("th", { scope: "col" }, "Title"),
    /*#__PURE__*/_createVNode("th", { scope: "col" }, "Start Date"),
    /*#__PURE__*/_createVNode("th", { scope: "col" }, "End Date")
  ])
], -1)
const _hoisted_94 = { key: 0 }
const _hoisted_95 = { class: "col-md-8 text-md-right" }
const _hoisted_96 = {
  key: 0,
  class: "with-spinner-btn"
}
const _hoisted_97 = /*#__PURE__*/_createVNode("span", {
  class: "spinner-border",
  role: "status"
}, null, -1)
const _hoisted_98 = /*#__PURE__*/_createVNode("span", { class: "ml-2" }, "Loading...", -1)
const _hoisted_99 = {
  key: 1,
  class: "ml-2"
}
const _hoisted_100 = {
  key: 0,
  class: "with-spinner-btn"
}
const _hoisted_101 = /*#__PURE__*/_createVNode("span", {
  class: "spinner-border",
  role: "status"
}, null, -1)
const _hoisted_102 = /*#__PURE__*/_createVNode("span", { class: "ml-2" }, "Loading...", -1)
const _hoisted_103 = {
  key: 1,
  class: "ml-2"
}
const _hoisted_104 = { class: "modal-wrap default-modal" }
const _hoisted_105 = {
  class: "modal fade",
  id: "deleteAcknowledgementInvitationModal",
  tabindex: "-1",
  "aria-labelledby": "deleteModalLabel",
  "aria-hidden": "true"
}
const _hoisted_106 = { class: "modal-dialog modal-dialog-centered modal-sm" }
const _hoisted_107 = { class: "modal-content" }
const _hoisted_108 = { class: "modal-header" }
const _hoisted_109 = /*#__PURE__*/_createVNode("h5", {
  class: "modal-title",
  id: "deleteModalLabel"
}, " Invitation Decline ", -1)
const _hoisted_110 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_111 = { class: "modal-body" }
const _hoisted_112 = /*#__PURE__*/_createVNode("div", {
  class: "alert alert-danger mb-0",
  role: "alert"
}, " Are you sure ? You want to decline the Invitation Request. ", -1)
const _hoisted_113 = { class: "form-group" }
const _hoisted_114 = /*#__PURE__*/_createVNode("label", { for: "exampleInputEmail1" }, "Reason to Decline", -1)
const _hoisted_115 = { class: "modal-footer" }
const _hoisted_116 = {
  key: 0,
  class: "with-spinner-btn"
}
const _hoisted_117 = /*#__PURE__*/_createVNode("span", {
  class: "spinner-border",
  role: "status"
}, null, -1)
const _hoisted_118 = /*#__PURE__*/_createVNode("span", { class: "ml-2" }, "Loading...", -1)
const _hoisted_119 = {
  key: 1,
  class: "ml-2"
}
const _hoisted_120 = { class: "modal-wrap default-modal" }
const _hoisted_121 = {
  class: "modal fade",
  id: "deleteSelectedInvitation",
  tabindex: "-1",
  "aria-labelledby": "deleteModalLabel",
  "aria-hidden": "true"
}
const _hoisted_122 = { class: "modal-dialog modal-dialog-centered modal-sm" }
const _hoisted_123 = { class: "modal-content" }
const _hoisted_124 = { class: "modal-header" }
const _hoisted_125 = /*#__PURE__*/_createVNode("h5", {
  class: "modal-title",
  id: "deleteModalLabel"
}, " Decline Selected Task ", -1)
const _hoisted_126 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_127 = { class: "modal-body" }
const _hoisted_128 = /*#__PURE__*/_createVNode("div", {
  class: "alert alert-danger mb-0",
  role: "alert"
}, " Are you sure ? You want to decline the selected Task Invitation. ", -1)
const _hoisted_129 = { class: "form-group" }
const _hoisted_130 = /*#__PURE__*/_createVNode("label", { for: "exampleInputEmail1" }, "Reason to Decline", -1)
const _hoisted_131 = { class: "modal-footer" }
const _hoisted_132 = {
  key: 0,
  class: "with-spinner-btn"
}
const _hoisted_133 = /*#__PURE__*/_createVNode("span", {
  class: "spinner-border",
  role: "status"
}, null, -1)
const _hoisted_134 = /*#__PURE__*/_createVNode("span", { class: "ml-2" }, "Loading...", -1)
const _hoisted_135 = {
  key: 1,
  class: "ml-2"
}
const _hoisted_136 = { class: "modal-wrap default-modal" }
const _hoisted_137 = {
  class: "modal fade",
  "data-backdrop": "static",
  "data-keyboard": "false",
  id: "generateConfirmationModal",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_138 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_139 = { class: "modal-content" }
const _hoisted_140 = { class: "modal-header" }
const _hoisted_141 = /*#__PURE__*/_createVNode("div", { class: "d-block" }, [
  /*#__PURE__*/_createVNode("h5", {
    class: "modal-title",
    id: "exampleModalLabel"
  }, " Task Invitation Confirmation ")
], -1)
const _hoisted_142 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_143 = { class: "modal-body" }
const _hoisted_144 = /*#__PURE__*/_createVNode("p", null, "Do you want to Accept Task Invitation ?", -1)
const _hoisted_145 = {
  key: 0,
  class: "with-spinner-btn"
}
const _hoisted_146 = /*#__PURE__*/_createVNode("span", {
  class: "spinner-border",
  role: "status"
}, null, -1)
const _hoisted_147 = /*#__PURE__*/_createVNode("span", { class: "ml-2" }, "Loading...", -1)
const _hoisted_148 = {
  key: 1,
  class: "ml-2"
}
const _hoisted_149 = { class: "modal-wrap default-modal" }
const _hoisted_150 = {
  class: "modal fade",
  "data-backdrop": "static",
  "data-keyboard": "false",
  id: "redirectFromInvitation",
  tabindex: -1,
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_151 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_152 = { class: "modal-content" }
const _hoisted_153 = { class: "modal-header" }
const _hoisted_154 = /*#__PURE__*/_createVNode("div", { class: "d-block" }, [
  /*#__PURE__*/_createVNode("h5", {
    class: "modal-title",
    id: "exampleModalLabel"
  }, " Redirection Option ")
], -1)
const _hoisted_155 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_156 = { class: "modal-body" }
const _hoisted_157 = /*#__PURE__*/_createVNode("span", { class: "sb-nav-link-icon" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-home" })
], -1)
const _hoisted_158 = /*#__PURE__*/_createTextVNode(" Go To Dashboard ")
const _hoisted_159 = { key: 0 }
const _hoisted_160 = { class: "modal-wrap default-modal" }
const _hoisted_161 = {
  class: "modal fade",
  "data-backdrop": "static",
  "data-keyboard": "false",
  id: "showTasks",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_162 = { class: "modal-dialog modal-dialog-centered modal-lg" }
const _hoisted_163 = { class: "modal-content" }
const _hoisted_164 = { class: "modal-header" }
const _hoisted_165 = {
  key: 0,
  class: "modal-title",
  id: "exampleModalLabel"
}
const _hoisted_166 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_167 = { class: "modal-body" }
const _hoisted_168 = { class: "form-wrap pt-0" }
const _hoisted_169 = { class: "table-responsive mb-3 font-12" }
const _hoisted_170 = { class: "table table-bordered table-shadowed mb-0" }
const _hoisted_171 = /*#__PURE__*/_createVNode("thead", { class: "table-primary nowrap-text" }, [
  /*#__PURE__*/_createVNode("tr", null, [
    /*#__PURE__*/_createVNode("th", { scope: "col" }, "Item Name"),
    /*#__PURE__*/_createVNode("th", { scope: "col" }, "Item Description"),
    /*#__PURE__*/_createVNode("th", { scope: "col" }, "Item Cost"),
    /*#__PURE__*/_createVNode("th", { scope: "col" }, "Quantity")
  ])
], -1)
const _hoisted_172 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ErrorList = _resolveComponent("ErrorList")
  const _component_ToDoDetailsAttachment = _resolveComponent("ToDoDetailsAttachment")
  const _component_ToDoMembersListForTaskTable = _resolveComponent("ToDoMembersListForTaskTable")
  const _component_CheckAvaibilityByUser = _resolveComponent("CheckAvaibilityByUser")
  const _component_SuccessfulModalCustom = _resolveComponent("SuccessfulModalCustom")

  return (_openBlock(), _createBlock(_Fragment, null, [
    (_ctx.state.ui.isLoading.phaseAcknowledgement)
      ? (_openBlock(), _createBlock("div", _hoisted_1, [
          _hoisted_2
        ]))
      : (_openBlock(), _createBlock("div", _hoisted_3, [
          _createVNode("div", _hoisted_4, [
            (
        _ctx.state.data.acknowledgementDetails &&
        _ctx.state.data.acknowledgementDetails.phase &&
        _ctx.state.data.acknowledgementDetails.phase.name &&
        _ctx.state.data.acknowledgementDetails.type === 6
      )
              ? (_openBlock(), _createBlock("h1", _hoisted_5, [
                  _hoisted_6,
                  _createTextVNode("Acknowledgement Invitation for Phase of " + _toDisplayString(_ctx.state.data.acknowledgementDetails.phase.name), 1)
                ]))
              : _createCommentVNode("", true),
            (
        _ctx.state.data.acknowledgementDetails &&
        _ctx.state.data.acknowledgementDetails.phase &&
        _ctx.state.data.acknowledgementDetails.phase.name &&
        _ctx.state.data.acknowledgementDetails.type === 10
      )
              ? (_openBlock(), _createBlock("h1", _hoisted_7, [
                  _hoisted_8,
                  _createTextVNode("Acknowledgement Invitation for Task of " + _toDisplayString(_ctx.state.data.acknowledgementDetails.phase.name), 1)
                ]))
              : _createCommentVNode("", true)
          ]),
          _createVNode("div", _hoisted_9, [
            _createVNode(_component_ErrorList, {
              errors: _ctx.state.ui.errors.errorList.phaseAcknowledgement,
              hasError: _ctx.state.ui.errors.hasError
            }, null, 8, ["errors", "hasError"]),
            _createVNode("div", _hoisted_10, [
              _createVNode("div", _hoisted_11, [
                (
            _ctx.state.data.acknowledgementDetails &&
            _ctx.state.data.acknowledgementDetails.payers &&
            _ctx.state.data.acknowledgementDetails.payers.length
          )
                  ? (_openBlock(), _createBlock("div", _hoisted_12, [
                      _hoisted_13,
                      _createVNode("div", _hoisted_14, [
                        _createVNode("div", _hoisted_15, [
                          _createVNode("ul", null, [
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data
                    .acknowledgementDetails.payers, (payer, payerIndex) => {
                              return (_openBlock(), _createBlock("li", { key: payerIndex }, [
                                (payer.full_name)
                                  ? (_openBlock(), _createBlock("span", _hoisted_16, _toDisplayString(payer.full_name), 1))
                                  : _createCommentVNode("", true),
                                (payer.email)
                                  ? (_openBlock(), _createBlock("span", _hoisted_17, "(" + _toDisplayString(payer.email) + ")", 1))
                                  : _createCommentVNode("", true)
                              ]))
                            }), 128))
                          ])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (
            _ctx.state.data.acknowledgementDetails &&
            _ctx.state.data.acknowledgementDetails.phase_detail &&
            _ctx.state.data.acknowledgementDetails.phase_detail.invitations &&
            !_ctx.state.data.acknowledgementDetails.showGeneral
          )
                  ? (_openBlock(), _createBlock("div", _hoisted_18, [
                      _createVNode("ul", null, [
                        _hoisted_19,
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data
                .acknowledgementDetails.phase_detail.invitations, (member, memberIndex) => {
                          return (_openBlock(), _createBlock("li", { key: memberIndex }, [
                            (member.email)
                              ? (_openBlock(), _createBlock("span", _hoisted_20, "(" + _toDisplayString(member.email) + ")", 1))
                              : _createCommentVNode("", true)
                          ]))
                        }), 128))
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createVNode("div", _hoisted_21, [
                _createVNode("button", {
                  class: "btn default-btn outline orange d-inline-block mb-0 mr-2",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.chatRedirect && _ctx.chatRedirect(...args)))
                }, [
                  _hoisted_22,
                  _createTextVNode(_toDisplayString(_ctx.state.ui.isPostLoading.redirectToChat ? "loading..." : "Chat"), 1)
                ]),
                (
            _ctx.state.data.acknowledgementDetails.type === 6 &&
            _ctx.state.data.acknowledgementDetails.is_complete === 0 &&
            _ctx.state.data.acknowledgementDetails.is_declined === 0 &&
            !_ctx.state.data.acknowledgementDetails.showGeneral
          )
                  ? (_openBlock(), _createBlock("button", {
                      key: 0,
                      class: "btn default-btn outline secondary d-inline-block mb-0 mr-2",
                      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.join && _ctx.join(...args))),
                      disabled: _ctx.state.ui.isPostLoading.acceptInvitation
            ? _ctx.state.ui.isPostLoading.acceptInvitation
            : false
            
                    }, [
                      (_ctx.state.ui.isPostLoading.acceptInvitation === true)
                        ? (_openBlock(), _createBlock("span", _hoisted_23, [
                            _hoisted_24,
                            _hoisted_25
                          ]))
                        : (_openBlock(), _createBlock("span", _hoisted_26, "Acknowledge"))
                    ], 8, ["disabled"]))
                  : _createCommentVNode("", true),
                (
            _ctx.state.data.acknowledgementDetails.type === 6 &&
            _ctx.state.data.acknowledgementDetails.is_complete === 0 &&
            _ctx.state.data.acknowledgementDetails.is_declined === 0 &&
            !_ctx.state.data.acknowledgementDetails.showGeneral
          )
                  ? (_openBlock(), _createBlock("button", {
                      key: 1,
                      class: "btn default-btn outline danger d-inline-block mb-0",
                      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.showDeclineModal && _ctx.showDeclineModal(...args))),
                      disabled: _ctx.state.ui.isPostLoading.declineProject
            ? _ctx.state.ui.isPostLoading.declineProject
            : false
            
                    }, [
                      (_ctx.state.ui.isPostLoading.declineProject === true)
                        ? (_openBlock(), _createBlock("span", _hoisted_27, [
                            _hoisted_28,
                            _hoisted_29
                          ]))
                        : (_openBlock(), _createBlock("span", _hoisted_30, "Decline"))
                    ], 8, ["disabled"]))
                  : _createCommentVNode("", true)
              ])
            ]),
            (_ctx.state.data.acknowledgementDetails.type === 10)
              ? (_openBlock(), _createBlock("p", _hoisted_31, [
                  _hoisted_32
                ]))
              : _createCommentVNode("", true),
            (
        _ctx.state.data.acknowledgementDetails &&
        _ctx.state.data.acknowledgementDetails.phase &&
        _ctx.state.data.acknowledgementDetails.phase.name &&
        _ctx.state.data.acknowledgementDetails.phase.parent_phase &&
        _ctx.state.data.acknowledgementDetails.type === 10
      )
              ? (_openBlock(), _createBlock("p", _hoisted_33, _toDisplayString(_ctx.state.data.acknowledgementDetails.phase.parent_phase.name) + " of " + _toDisplayString(_ctx.state.data.acknowledgementDetails.phase.name), 1))
              : _createCommentVNode("", true),
            (_ctx.state.data.acknowledgementDetails.type != 10)
              ? (_openBlock(), _createBlock("p", _hoisted_34, [
                  _hoisted_35
                ]))
              : _createCommentVNode("", true),
            (
        _ctx.state.data.acknowledgementDetails &&
        _ctx.state.data.acknowledgementDetails.phase &&
        _ctx.state.data.acknowledgementDetails.phase.name &&
        _ctx.state.data.acknowledgementDetails.type != 10
      )
              ? (_openBlock(), _createBlock("p", _hoisted_36, _toDisplayString(_ctx.state.data.acknowledgementDetails.phase.name), 1))
              : _createCommentVNode("", true),
            (_ctx.state.data.acknowledgementDetails.type != 10)
              ? (_openBlock(), _createBlock("p", _hoisted_37, [
                  _hoisted_38
                ]))
              : _createCommentVNode("", true),
            (
        _ctx.state.data.acknowledgementDetails &&
        _ctx.state.data.acknowledgementDetails.phase &&
        _ctx.state.data.acknowledgementDetails.phase.description &&
        _ctx.state.data.acknowledgementDetails.type != 10
      )
              ? (_openBlock(), _createBlock("p", _hoisted_39, _toDisplayString(_ctx.state.data.acknowledgementDetails.phase.description), 1))
              : _createCommentVNode("", true),
            _createVNode("div", _hoisted_40, [
              (_ctx.state.data.acknowledgementDetails.phase)
                ? (_openBlock(), _createBlock("div", _hoisted_41, [
                    _createVNode("p", _hoisted_42, [
                      _hoisted_43,
                      _hoisted_44,
                      (_ctx.state.data.acknowledgementDetails.phase.localStartedDate)
                        ? (_openBlock(), _createBlock("span", _hoisted_45, _toDisplayString(_ctx.state.data.acknowledgementDetails.phase.localStartedDate), 1))
                        : _createCommentVNode("", true),
                      _hoisted_46,
                      (_ctx.state.data.acknowledgementDetails.phase.localEndDate)
                        ? (_openBlock(), _createBlock("span", _hoisted_47, _toDisplayString(_ctx.state.data.acknowledgementDetails.phase.localEndDate), 1))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (
          _ctx.state.data.acknowledgementDetails.phase &&
          _ctx.state.data.acknowledgementDetails.phase.task_updates
        )
                ? (_openBlock(), _createBlock("div", _hoisted_48, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data.acknowledgementDetails.phase.task_updates, (update, updateIndex) => {
                      return (_openBlock(), _createBlock("p", {
                        class: "mb-0",
                        key: updateIndex
                      }, [
                        _hoisted_49,
                        _hoisted_50,
                        (update.localUpdatedAt)
                          ? (_openBlock(), _createBlock("span", _hoisted_51, _toDisplayString(update.localUpdatedAt), 1))
                          : _createCommentVNode("", true),
                        _hoisted_52,
                        (update.reason)
                          ? (_openBlock(), _createBlock("span", _hoisted_53, _toDisplayString(update.reason), 1))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true),
              (
          _ctx.state.data.acknowledgementDetails.start_date &&
          _ctx.state.data.acknowledgementDetails.end_date
        )
                ? (_openBlock(), _createBlock("div", _hoisted_54, [
                    _createVNode("p", _hoisted_55, [
                      _hoisted_56,
                      _hoisted_57,
                      (_ctx.state.data.acknowledgementDetails.start_date)
                        ? (_openBlock(), _createBlock("span", _hoisted_58, _toDisplayString(_ctx.state.data.acknowledgementDetails.start_date), 1))
                        : _createCommentVNode("", true),
                      _hoisted_59,
                      (_ctx.state.data.acknowledgementDetails.end_date)
                        ? (_openBlock(), _createBlock("span", _hoisted_60, _toDisplayString(_ctx.state.data.acknowledgementDetails.end_date), 1))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createVNode("div", _hoisted_61, [
                (_ctx.state.data.acknowledgementDetails.estimation && _ctx.state.data.acknowledgementDetails.estimation.amount && _ctx.state.data.acknowledgementDetails.estimation.amount && _ctx.state.data.acknowledgementDetails.estimation.type)
                  ? (_openBlock(), _createBlock("div", _hoisted_62, [
                      _hoisted_63,
                      _createTextVNode(" $" + _toDisplayString(_ctx.state.data.acknowledgementDetails.estimation.amount) + " (" + _toDisplayString(_ctx.state.data.acknowledgementDetails.estimation.type) + ") ", 1)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            (
        _ctx.state.data.acknowledgementDetails.attachments &&
        _ctx.state.data.acknowledgementDetails.attachments.length
      )
              ? (_openBlock(), _createBlock("div", _hoisted_64, [
                  _hoisted_65,
                  _createVNode("ul", null, [
                    _createVNode("li", null, [
                      (
              _ctx.state.data.acknowledgementDetails.attachments &&
              _ctx.state.data.acknowledgementDetails.attachments.length
            )
                        ? (_openBlock(), _createBlock(_component_ToDoDetailsAttachment, {
                            key: 0,
                            todoAttachments: _ctx.state.data.acknowledgementDetails.attachments
                          }, null, 8, ["todoAttachments"]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.state.data.acknowledgementDetails.phase.edoc_id)
              ? (_openBlock(), _createBlock("p", _hoisted_66, "OR"))
              : _createCommentVNode("", true),
            (_ctx.state.data.acknowledgementDetails.phase.edoc_id)
              ? (_openBlock(), _createBlock("p", _hoisted_67, [
                  _hoisted_68
                ]))
              : _createCommentVNode("", true),
            (_ctx.state.data.acknowledgementDetails.phase.edoc_id)
              ? (_openBlock(), _createBlock("p", _hoisted_69, [
                  _createVNode("a", {
                    href: "javascript:void(0)",
                    class: "link-primary",
                    onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.redirectToDoc && _ctx.redirectToDoc(...args)))
                  }, _toDisplayString(_ctx.state.data.acknowledgementDetails.phase.edoc_id), 1)
                ]))
              : _createCommentVNode("", true),
            (
        _ctx.state.data.acknowledgementDetails.child_invitations &&
        _ctx.state.data.acknowledgementDetails.child_invitations.length
      )
              ? (_openBlock(), _createBlock("p", _hoisted_70, [
                  _hoisted_71
                ]))
              : _createCommentVNode("", true),
            (
        _ctx.state.data.acknowledgementDetails.child_invitations &&
        _ctx.state.data.acknowledgementDetails.child_invitations.length
      )
              ? (_openBlock(), _createBlock("div", _hoisted_72, [
                  _createVNode("table", _hoisted_73, [
                    _createVNode("thead", _hoisted_74, [
                      _createVNode("tr", null, [
                        (_ctx.state.data.acknowledgementDetails.type != 6)
                          ? (_openBlock(), _createBlock("th", _hoisted_75, [
                              _withDirectives(_createVNode("input", {
                                type: "checkbox",
                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.state.data.selectAll = $event))
                              }, null, 512), [
                                [_vModelCheckbox, _ctx.state.data.selectAll]
                              ]),
                              _hoisted_76
                            ]))
                          : _createCommentVNode("", true),
                        _hoisted_77,
                        _hoisted_78,
                        _hoisted_79,
                        _hoisted_80,
                        _hoisted_81
                      ])
                    ]),
                    _createVNode("tbody", null, [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data
              .acknowledgementDetails.child_invitations, (childPhase, childPhaseIndex) => {
                        return (_openBlock(), _createBlock("tr", { key: childPhaseIndex }, [
                          (_ctx.state.data.acknowledgementDetails.type != 6)
                            ? (_openBlock(), _createBlock("td", _hoisted_82, [
                                _withDirectives(_createVNode("input", {
                                  type: "checkbox",
                                  "onUpdate:modelValue": ($event: any) => (childPhase.phase_detail.phase.isChecked = $event),
                                  onChange: ($event: any) => (_ctx.check(childPhase))
                                }, null, 40, ["onUpdate:modelValue", "onChange"]), [
                                  [_vModelCheckbox, childPhase.phase_detail.phase.isChecked]
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          _createVNode("td", null, [
                            (
                  childPhase.phase_detail &&
                  childPhase.phase_detail.phase.name
                )
                              ? (_openBlock(), _createBlock("p", _hoisted_83, [
                                  _createTextVNode(_toDisplayString(childPhase.phase_detail.phase.name) + " ", 1),
                                  _createVNode("a", {
                                    href: "javascript:void(0)",
                                    class: "text-primary",
                                    onClick: ($event: any) => (_ctx.viewGroupTaskItems(childPhase.phase_detail.phase.estimation_items))
                                  }, [
                                    _hoisted_84
                                  ], 8, ["onClick"])
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          _createVNode("td", null, [
                            (
                  childPhase.phase_detail.phase &&
                  childPhase.phase_detail.phase.description
                )
                              ? (_openBlock(), _createBlock("p", _hoisted_85, _toDisplayString(childPhase.phase_detail.phase.description), 1))
                              : (_openBlock(), _createBlock("p", _hoisted_86, "-"))
                          ]),
                          _createVNode("td", null, [
                            (
                  childPhase.phase_detail &&
                  childPhase.phase_detail.phase &&
                  childPhase.phase_detail.phase.allMembers &&
                  childPhase.phase_detail.phase.allMembers.length
                )
                              ? (_openBlock(), _createBlock(_component_ToDoMembersListForTaskTable, {
                                  key: 0,
                                  projectMembers: childPhase.phase_detail.phase.allMembers
                                }, null, 8, ["projectMembers"]))
                              : (_openBlock(), _createBlock("p", _hoisted_87, "N/A"))
                          ]),
                          _createVNode("td", null, [
                            _createVNode("p", null, _toDisplayString(childPhase.phase_detail.phase.localStartedDate), 1)
                          ]),
                          _createVNode("td", null, [
                            _createVNode("p", null, _toDisplayString(childPhase.phase_detail.phase.localEndDate), 1)
                          ])
                        ]))
                      }), 128))
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (
        _ctx.state.data.acknowledgementDetails.time_slots &&
        _ctx.state.data.acknowledgementDetails.time_slots.length
      )
              ? (_openBlock(), _createBlock("div", _hoisted_88, [
                  _createVNode("button", {
                    onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.showCalender && _ctx.showCalender(...args))),
                    class: "btn default-btn d-inline-block mb-0 mr-2"
                  }, [
                    _hoisted_89
                  ]),
                  _createVNode("div", _hoisted_90, [
                    _hoisted_91,
                    _createVNode("table", _hoisted_92, [
                      _hoisted_93,
                      _createVNode("tbody", null, [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data
                .acknowledgementDetails.time_slots, (childPhase, childPhaseIndex) => {
                          return (_openBlock(), _createBlock("tr", { key: childPhaseIndex }, [
                            _createVNode("td", null, [
                              (childPhase.title)
                                ? (_openBlock(), _createBlock("p", _hoisted_94, _toDisplayString(childPhase.title), 1))
                                : _createCommentVNode("", true)
                            ]),
                            _createVNode("td", null, [
                              _createVNode("p", null, _toDisplayString(childPhase.localStartedDate), 1)
                            ]),
                            _createVNode("td", null, [
                              _createVNode("p", null, _toDisplayString(childPhase.localEndDate), 1)
                            ])
                          ]))
                        }), 128))
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            _createVNode("div", _hoisted_95, [
              (_ctx.isInvitatationSelected)
                ? (_openBlock(), _createBlock("button", {
                    key: 0,
                    class: "btn default-btn outline secondary d-inline-block mb-0 mr-2",
                    onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.showGenerateConfirmationModal && _ctx.showGenerateConfirmationModal(...args)))
                  }, [
                    (_ctx.state.ui.isPostLoading.acceptSelectedPhase)
                      ? (_openBlock(), _createBlock("span", _hoisted_96, [
                          _hoisted_97,
                          _hoisted_98
                        ]))
                      : (_openBlock(), _createBlock("span", _hoisted_99, _toDisplayString(_ctx.state.data.selectAll ? "Acknowledge All" : "Acknowledge"), 1))
                  ]))
                : _createCommentVNode("", true),
              (_ctx.isInvitatationSelected)
                ? (_openBlock(), _createBlock("button", {
                    key: 1,
                    class: "btn default-btn outline danger d-inline-block mb-0",
                    onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.showSelectedDeclineModal && _ctx.showSelectedDeclineModal(...args)))
                  }, [
                    (_ctx.state.ui.isPostLoading.declineProject === true)
                      ? (_openBlock(), _createBlock("span", _hoisted_100, [
                          _hoisted_101,
                          _hoisted_102
                        ]))
                      : (_openBlock(), _createBlock("span", _hoisted_103, _toDisplayString(_ctx.state.data.selectAll ? "Decline All" : "Decline"), 1))
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ])),
    _createVNode("div", _hoisted_104, [
      _createVNode("div", _hoisted_105, [
        _createVNode("div", _hoisted_106, [
          _createVNode("div", _hoisted_107, [
            _createVNode("div", _hoisted_108, [
              _hoisted_109,
              _createVNode("button", {
                type: "button",
                class: "close",
                "data-dismiss": "modal",
                onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.closeAcknowledgementInvitationModal && _ctx.closeAcknowledgementInvitationModal(...args))),
                "aria-label": "Close"
              }, [
                _hoisted_110
              ])
            ]),
            _createVNode("div", _hoisted_111, [
              _hoisted_112,
              _createVNode("div", _hoisted_113, [
                _hoisted_114,
                _withDirectives(_createVNode("input", {
                  type: "email",
                  class: "form-control",
                  id: "description",
                  "aria-describedby": "emailHelp",
                  placeholder: "Provide the Reason for Decline",
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.state.data.acknowledgementDetails.description = $event))
                }, null, 512), [
                  [_vModelText, _ctx.state.data.acknowledgementDetails.description]
                ])
              ])
            ]),
            _createVNode("div", _hoisted_115, [
              _createVNode("button", {
                class: "btn default-btn outline danger d-inline-block mb-0",
                onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.decline && _ctx.decline(...args))),
                disabled: _ctx.state.ui.isPostLoading.declineProject
              ? _ctx.state.ui.isPostLoading.declineProject
              : false
              
              }, [
                (_ctx.state.ui.isPostLoading.declineProject === true)
                  ? (_openBlock(), _createBlock("span", _hoisted_116, [
                      _hoisted_117,
                      _hoisted_118
                    ]))
                  : (_openBlock(), _createBlock("span", _hoisted_119, "Decline"))
              ], 8, ["disabled"]),
              _createVNode("button", {
                type: "button",
                class: "btn secondary-btn",
                "data-dismiss": "modal",
                onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.closeAcknowledgementInvitationModal && _ctx.closeAcknowledgementInvitationModal(...args)))
              }, " No ")
            ])
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_120, [
      _createVNode("div", _hoisted_121, [
        _createVNode("div", _hoisted_122, [
          _createVNode("div", _hoisted_123, [
            _createVNode("div", _hoisted_124, [
              _hoisted_125,
              _createVNode("button", {
                type: "button",
                class: "close",
                "data-dismiss": "modal",
                onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.hideSelectedDeclineModal && _ctx.hideSelectedDeclineModal(...args))),
                "aria-label": "Close"
              }, [
                _hoisted_126
              ])
            ]),
            _createVNode("div", _hoisted_127, [
              _createVNode(_component_ErrorList, {
                errors: _ctx.state.ui.errors.errorList.declineTaskInvitations,
                hasError: _ctx.state.ui.errors.hasError
              }, null, 8, ["errors", "hasError"]),
              _hoisted_128,
              _createVNode("div", _hoisted_129, [
                _hoisted_130,
                _withDirectives(_createVNode("input", {
                  type: "email",
                  class: "form-control",
                  id: "description",
                  "aria-describedby": "emailHelp",
                  placeholder: "Provide the Reason for Decline",
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_ctx.state.data.acknowledgementDetails.description = $event))
                }, null, 512), [
                  [_vModelText, _ctx.state.data.acknowledgementDetails.description]
                ])
              ])
            ]),
            _createVNode("div", _hoisted_131, [
              _createVNode("button", {
                class: "btn default-btn outline danger d-inline-block mb-0",
                onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.declineSelectedPhase && _ctx.declineSelectedPhase(...args))),
                disabled: _ctx.state.ui.isPostLoading.declineSelectedPhase
              ? _ctx.state.ui.isPostLoading.declineSelectedPhase
              : false
              
              }, [
                (_ctx.state.ui.isPostLoading.declineSelectedPhase === true)
                  ? (_openBlock(), _createBlock("span", _hoisted_132, [
                      _hoisted_133,
                      _hoisted_134
                    ]))
                  : (_openBlock(), _createBlock("span", _hoisted_135, "Decline"))
              ], 8, ["disabled"]),
              _createVNode("button", {
                type: "button",
                class: "btn secondary-btn",
                "data-dismiss": "modal",
                onClick: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.hideSelectedDeclineModal && _ctx.hideSelectedDeclineModal(...args)))
              }, " No ")
            ])
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_136, [
      _createVNode("div", _hoisted_137, [
        _createVNode("div", _hoisted_138, [
          _createVNode("div", _hoisted_139, [
            _createVNode("div", _hoisted_140, [
              _hoisted_141,
              _createVNode("button", {
                type: "button",
                class: "close",
                onClick: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.hideGenerateConfirmationModal && _ctx.hideGenerateConfirmationModal(...args))),
                "aria-label": "Close"
              }, [
                _hoisted_142
              ])
            ]),
            _createVNode("div", _hoisted_143, [
              _createVNode(_component_ErrorList, {
                errors: _ctx.state.ui.errors.errorList.phaseAcknowledgement,
                hasError: _ctx.state.ui.errors.hasError
              }, null, 8, ["errors", "hasError"]),
              _hoisted_144,
              _createVNode("button", {
                type: "button",
                class: "btn default-btn mr-2 mt-3",
                disabled: _ctx.state.ui.isPostLoading.acceptSelectedPhase
              ? _ctx.state.ui.isPostLoading.acceptSelectedPhase
              : false
              ,
                onClick: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_ctx.acceptSelectedPhase && _ctx.acceptSelectedPhase(...args)))
              }, [
                (_ctx.state.ui.isPostLoading.acceptSelectedPhase === true)
                  ? (_openBlock(), _createBlock("span", _hoisted_145, [
                      _hoisted_146,
                      _hoisted_147
                    ]))
                  : (_openBlock(), _createBlock("span", _hoisted_148, _toDisplayString(_ctx.state.data.selectAll ? "Acknowledge All" : "Acknowledge"), 1))
              ], 8, ["disabled"]),
              _createVNode("button", {
                type: "button",
                class: "btn default-btn mt-3",
                onClick: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.hideGenerateConfirmationModal && _ctx.hideGenerateConfirmationModal(...args)))
              }, " No ")
            ])
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_149, [
      _createVNode("div", _hoisted_150, [
        _createVNode("div", _hoisted_151, [
          _createVNode("div", _hoisted_152, [
            _createVNode("div", _hoisted_153, [
              _hoisted_154,
              _createVNode("button", {
                type: "button",
                class: "close",
                onClick: _cache[20] || (_cache[20] = 
//@ts-ignore
(...args) => (_ctx.hideRedirectFromInvitation && _ctx.hideRedirectFromInvitation(...args))),
                "aria-label": "Close"
              }, [
                _hoisted_155
              ])
            ]),
            _createVNode("div", _hoisted_156, [
              _createVNode("button", {
                type: "button",
                class: "btn default-btn mr-2 mb-2",
                onClick: _cache[21] || (_cache[21] = 
//@ts-ignore
(...args) => (_ctx.redirectToDashboard && _ctx.redirectToDashboard(...args)))
              }, [
                _hoisted_157,
                _hoisted_158
              ]),
              _createVNode("button", {
                type: "button",
                class: "btn default-btn mr-2 mb-2",
                onClick: _cache[22] || (_cache[22] = 
//@ts-ignore
(...args) => (_ctx.redirectToPhaseListDashboard && _ctx.redirectToPhaseListDashboard(...args)))
              }, " Go To Phase Dashboard "),
              _createVNode("button", {
                type: "button",
                class: "btn default-btn mr-2 mb-2",
                onClick: _cache[23] || (_cache[23] = 
//@ts-ignore
(...args) => (_ctx.redirectToPhaseDetails && _ctx.redirectToPhaseDetails(...args)))
              }, " Go To Phase Details "),
              (
              _ctx.state.data.acknowledgementDetails.child_invitations &&
              _ctx.state.data.acknowledgementDetails.child_invitations.length
            )
                ? (_openBlock(), _createBlock("div", _hoisted_159))
                : _createCommentVNode("", true),
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data
              .acknowledgementDetails.child_invitations, (childPhase, childPhaseIndex) => {
                return (_openBlock(), _createBlock("button", {
                  key: childPhaseIndex,
                  type: "button",
                  class: "btn default-btn mr-2",
                  onClick: ($event: any) => (_ctx.goToTaskDetails(childPhase.phase_detail.phase.uuid))
                }, " Go To Task of " + _toDisplayString(childPhase.phase_detail.phase.name), 9, ["onClick"]))
              }), 128))
            ])
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_160, [
      _createVNode("div", _hoisted_161, [
        _createVNode("div", _hoisted_162, [
          _createVNode("div", _hoisted_163, [
            _createVNode("div", _hoisted_164, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data
              .acknowledgementDetails.child_invitations, (childPhase, childPhaseIndex) => {
                return (_openBlock(), _createBlock("div", {
                  class: "d-block",
                  key: childPhaseIndex
                }, [
                  (
                childPhase.phase_detail &&
                childPhase.phase_detail.phase.name
              )
                    ? (_openBlock(), _createBlock("h5", _hoisted_165, _toDisplayString(childPhase.phase_detail.phase.name) + "'s Items List", 1))
                    : _createCommentVNode("", true)
                ]))
              }), 128)),
              _createVNode("button", {
                type: "button",
                class: "close",
                onClick: _cache[24] || (_cache[24] = 
//@ts-ignore
(...args) => (_ctx.hideTasksModal && _ctx.hideTasksModal(...args))),
                "aria-label": "Close"
              }, [
                _hoisted_166
              ])
            ]),
            _createVNode("div", _hoisted_167, [
              _createVNode("div", _hoisted_168, [
                _createVNode("div", _hoisted_169, [
                  _createVNode("table", _hoisted_170, [
                    _hoisted_171,
                    (_ctx.state.data.estimationItems && _ctx.state.data.estimationItems.length)
                      ? (_openBlock(), _createBlock("tbody", _hoisted_172, [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data.estimationItems, (item, index) => {
                            return (_openBlock(), _createBlock("tr", {
                              key: item.id || index
                            }, [
                              _createVNode("td", null, [
                                _createVNode("p", null, _toDisplayString(item.name ? item.name : _ctx.$t('n_a')), 1)
                              ]),
                              _createVNode("td", null, [
                                _createVNode("p", null, _toDisplayString(item.description ? item.description : _ctx.$t('n_a')), 1)
                              ]),
                              _createVNode("td", null, [
                                _createVNode("p", null, _toDisplayString(item.cost ? item.cost : _ctx.$t('n_a')), 1)
                              ]),
                              _createVNode("td", null, [
                                _createVNode("p", null, _toDisplayString(item.quantity ? item.quantity : _ctx.$t('n_a')), 1)
                              ])
                            ]))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    (_ctx.state.data.showAvailibilityModal)
      ? (_openBlock(), _createBlock(_component_CheckAvaibilityByUser, {
          key: 2,
          activeTab: `Phase`,
          disabled: true,
          static: true,
          phaseDetails: _ctx.state.data.acknowledgementDetails,
          selectedEmail: _ctx.state.data.activeUserEmail,
          startDate: _ctx.state.data.acknowledgementDetails.phase.start_date,
          endDate: _ctx.state.data.acknowledgementDetails.phase.end_date,
          from: 'acknowledgement',
          isActive: _ctx.state.data.showAvailibilityModal,
          userDetails: _ctx.state.data.selectedUserSlotDetails,
          onHideAvaibilityModal: _ctx.hideAvaibilityModal
        }, null, 8, ["phaseDetails", "selectedEmail", "startDate", "endDate", "isActive", "userDetails", "onHideAvaibilityModal"]))
      : _createCommentVNode("", true),
    (_ctx.state.data.showSuccesCustomModal)
      ? (_openBlock(), _createBlock(_component_SuccessfulModalCustom, {
          key: 3,
          onClose: _ctx.closeSuccessCustomModal,
          showModal: _ctx.state.data.showSuccesCustomModal,
          titleMessage: _ctx.state.data.successFulMessage
        }, null, 8, ["onClose", "showModal", "titleMessage"]))
      : _createCommentVNode("", true)
  ], 64))
}